// Pitch text rules, shared by the two places a creator writes one (PIT-78).
//
// The profile's "My Pitch" editor (PIT-25) and the per-campaign apply composer
// are the same act of writing at different targets, so they answer to the same
// rule. Extracted rather than copied for the reason PIT-64 extracted the
// profile form: a bound that lives in two places is a bound that will disagree
// with itself, and the disagreement shows up as a pitch a creator can save on
// their profile but cannot send.

/** Suggested length is 250–500 words; these bounds keep a pitch substantive without letting it sprawl. */
export const MIN_PITCH_CHARS = 50;
export const MAX_PITCH_CHARS = 3000;

/** Words in a pitch, for the live counter under the editor. */
export function countWords(text: string): number {
  return text.trim().split(/\s+/).filter(Boolean).length;
}

/**
 * Validate pitch text. Returns the message to show, or an empty string when
 * the pitch is fine — the shape the existing editor already renders.
 *
 * `emptyMessage` differs by context: the profile editor asks for a pitch in
 * general, the apply composer asks for one aimed at this campaign.
 */
export function validatePitch(
  text: string,
  emptyMessage = 'Add a pitch so brands can hear your voice.'
): string {
  const trimmed = text.trim();
  if (trimmed.length === 0) return emptyMessage;
  if (trimmed.length < MIN_PITCH_CHARS) {
    return `Too short — aim for at least ${MIN_PITCH_CHARS} characters.`;
  }
  // Length is checked against the raw text, not the trimmed copy: what is
  // stored is what was typed, so the ceiling applies to the same thing.
  if (text.length > MAX_PITCH_CHARS) {
    return `Too long — keep it under ${MAX_PITCH_CHARS} characters.`;
  }
  return '';
}
